import PropTypes from 'prop-types'

import ExportAllDataModal from './ExportAllDataModal/ExportAllDataModal.component'
import ExportRawDataModal from './ExportRawDataModal/ExportRawDataModal.component'

const ExportDataModal = (props) =>
  props.selectedOrdersIds.length ? (
    <ExportRawDataModal
      onClose={props.onClose}
      selectedOrders={props.selectedOrdersIds}
      orderExportIntegrations={props.orderExportIntegrations}
      handleExportAction={props.handleExportAction}
      allowMarkOrderExported={props.allowMarkOrderExported}
      trackExportRawDataModalSubmitted={props.trackExportRawDataModalSubmitted}
    />
  ) : (
    <ExportAllDataModal
      onClose={props.onClose}
      orderExportIntegrations={props.orderExportIntegrations}
      handleExportAction={props.handleExportAction}
      statusFilter={props.statusFilter}
      allowMarkOrderExported={props.allowMarkOrderExported}
      trackExportAllDataModalSubmitted={props.trackExportAllDataModalSubmitted}
    />
  )

ExportDataModal.propTypes = {
  onClose: PropTypes.func,
  selectedOrdersIds: PropTypes.arrayOf(PropTypes.string),
  orderExportIntegrations: PropTypes.arrayOf(PropTypes.object),
  handleExportAction: PropTypes.func.isRequired,
  statusFilter: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowMarkOrderExported: PropTypes.bool,
  trackExportRawDataModalSubmitted: PropTypes.func,
  trackExportAllDataModalSubmitted: PropTypes.func,
}

ExportDataModal.defaultProps = {
  onClose: () => {},
  allowMarkOrderExported: false,
  selectedOrdersIds: [],
  orderExportIntegrations: [],
  trackExportRawDataModalSubmitted: () => {},
  trackExportAllDataModalSubmitted: () => {},
}

export default ExportDataModal
